__turbopack_context__.v({
  "mapContainer": "MapComponent-module-scss-module__3lSzfa__mapContainer",
  "mapWrapper": "MapComponent-module-scss-module__3lSzfa__mapWrapper",
  "markerAgencyAddress": "MapComponent-module-scss-module__3lSzfa__markerAgencyAddress",
  "markerAgencyName": "MapComponent-module-scss-module__3lSzfa__markerAgencyName",
  "markerLabelText": "MapComponent-module-scss-module__3lSzfa__markerLabelText",
  "markerLink": "MapComponent-module-scss-module__3lSzfa__markerLink",
});
